export enum EventStaticFieldIds {
  CoverImage = 'coverImage',
  EventDetails = 'eventDetails',
  HostInfo = 'hostInfo',
  Attendees = 'attendees',
}

export type VisibleFieldIds = Partial<Record<EventStaticFieldIds, boolean>>

export interface EventsListBlockLayout {
  viewStyle: 'card' | 'list' | 'feed'
  cardSize?: 'small' | 'medium' | 'large'
  cardStyle?: 'simple' | 'modern'
}

export enum EventTabIds {
  Upcoming = 'upcoming',
  Past = 'past',
  Ongoing = 'ongoing',
}
